import styled from 'styled-components/macro';
import ReactSelect from 'react-select';

export const Container = styled.div`
  padding: 5px 0 5px 0;
  width: 100%;
  opacity: ${({ disabled }) => (disabled ? '.3' : '1')};
`;

export const Label = styled.label`
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
  width: 100%;
  opacity: ${({ shouldShow }) => (shouldShow ? 1 : 0)};
  transition: opacity 0.3s;
`;

export const InputWrapper = styled.div`
  width: 100%;
  height: 30px;
  border-bottom: solid 1px
    ${({ theme, errorColor }) => (errorColor ? theme.red : theme.dark)};
  display: flex;
  align-items: center;

  > svg {
    color: ${({ theme }) => theme.gray2};
    width: 20px;
    margin-left: 5px;
  }
  > div {
    width: 100%;
  }
`;

export const Select = styled(ReactSelect)`
  .select__control {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    color: ${({ theme }) => theme.gray2};
    height: 30px;
    width: ${({ width }) => (width ? `${width}px` : '100%')} !important;
    background-color: transparent;

    .select__value-container {
      height: 30px;
      padding: 0 0 0 10px;
      font-family: ${({ theme }) => theme.primaryFontMedium};
      font-size: ${({ theme }) => theme.paragraph}px;

      .select__single-value {
        color: ${({ theme }) => theme.dark2} !important;
        text-transform: capitalize;
      }

      .select__multi-value {
        background-color: ${({ theme }) => theme.light};
        color: ${({ theme }) => theme.gray2};

        .select__multi-value__label {
          padding-top: 6px;
          background-color: ${({ theme }) => theme.light};
        }
      }
    }

    .select__indicator-separator {
      display: none;
    }

    .select__dropdown-indicator,
    .select__clear-indicator {
      padding: 0;
      color: ${({ theme }) => theme.gray2};
      margin-bottom: 8px;
    }
  }

  .select__menu {
    border-radius: 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    margin-top: 0;
    font-family: ${({ theme }) => theme.primaryFontLight};
    background-color: ${({ theme }) => theme.light};
    z-index: 6;
    text-transform: capitalize;
  }
`;
